import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  operadores: [],
  operador: {},
  routes: [],
  queues: [],
  departamentos: [],
  operadoresMonitor: [],
  gruposDeRotas: [],
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
